import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/mapConfig'

export const confMapsService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    syncFirebase
};

function syncFirebase() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'GET',{})
}

function search(offset, max, dataFilter) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: dataFilter, showAlert:false })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET',{})
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE', {})
}